import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { PersonalityDialogComponent } from './dialogs/personality-dialog/personality-dialog.component';
import { Routes } from '@angular/router';

import { EditDialogComponent } from './dialogs/edit-dialog/edit-dialog.component';

import { ReadingRoomComponent } from './reading-room/reading-room.component';
import { EmailWriterComponent } from './email-writer/email-writer.component';
import { EmailOptionsComponent } from './dialogs/email-options/email-options.component';
import { SubscribeDialogComponent } from './dialogs/subscribe-dialog/subscribe-dialog.component';
import { TeamAiDragDropDialogComponent } from './dialogs/team-ai-drag-drop-dialog/team-ai-drag-drop-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { VoiceDialogComponent } from './dialogs/voice-dialog/voice-dialog.component';
import { TennisServeComponent } from './tennis-serve/tennis-serve.component';
import { SafeYoutubePipe } from './pipes/components/safe-youtube.pipe';

import { ImageLibraryComponent } from './image-library/image-library.component';
import { CalendarNotesComponent } from './calendar-notes/calendar-notes.component';

import { ResumeBuilderComponent } from './resume-builder/resume-builder.component';
import { ResumeHomieComponent } from './resume-homie/resume-homie.component';
import { MediaLibraryComponent } from './media-library/media-library.component';
import { EditMediaDialogComponent } from './dialogs/edit-media-dialog/edit-media-dialog.component';

import { QuackstudioComponent } from './quackstudio/quackstudio.component';
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { DatadeletionComponent } from './datadeletion/datadeletion.component';
import { KayakIntegrationComponent } from './kayak-integration/kayak-integration.component';
import { SuperImageStudioComponent } from './super-image-studio/super-image-studio.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MediaLibraryPhotoViewerDialogComponent } from './dialogs/media-library-photo-viewer-dialog/media-library-photo-viewer-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { BodyMassTrackerComponent } from './body-mass-tracker/body-mass-tracker.component';

export const componentsRoutes: Routes = [
  {
    path: '',
    redirectTo: 'personality',
    pathMatch: 'full'
  },

      {
    path: 'resume1',
    component: ResumeBuilderComponent
  },
     {
    path: 'resume',
    component: ResumeHomieComponent
  },

  {
    path: 'tennis-serve',
    component: TennisServeComponent
  },
  {
    path: 'body-mass',
    component: BodyMassTrackerComponent
  },
  {
    path: 'calendar',
    component: CalendarNotesComponent
  },
  {
    path: 'scrum-board',
    loadComponent: () =>
      import('./scrum-board/scrum-board.component').then(m => m.ScrumBoardComponent)
  },

  {
    path: 'email',
    component: EmailWriterComponent
  },
    {
    path: 'media-library',
    component: MediaLibraryComponent
  },

  {
    path: 'reading-room',
    component: ReadingRoomComponent
  },
 
  {
    path: 'voice-adam',
    component: VoiceDialogComponent
  },
  {
  path: 'copy',
  component: QuackstudioComponent
},
{
  path: 'privacypolicy',
  component: PrivacypolicyComponent
},
  {
  path: 'datadeletion',
  component: DatadeletionComponent
},
  {
    path: 'integrations/kayak',
    component: KayakIntegrationComponent
  },
  {
    path: 'studio-plus',
    component: SuperImageStudioComponent
  }
];

@NgModule({
  declarations: [
    PersonalityDialogComponent,
    EditDialogComponent,
    ReadingRoomComponent,
    EmailWriterComponent,
    EmailOptionsComponent,
    SubscribeDialogComponent,

    TeamAiDragDropDialogComponent,
    VoiceDialogComponent,
   TennisServeComponent,
    SafeYoutubePipe,
    EditMediaDialogComponent,
    ImageLibraryComponent,
    CalendarNotesComponent,
    ResumeBuilderComponent,
    ResumeHomieComponent,
    MediaLibraryComponent,
    EditMediaDialogComponent,
    QuackstudioComponent,
    PrivacypolicyComponent,
    DatadeletionComponent,
    KayakIntegrationComponent,
    SuperImageStudioComponent,
    MediaLibraryPhotoViewerDialogComponent,
    BodyMassTrackerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    DragDropModule,
    MatDialogModule
  ]
})
export class ComponentsModule {}

export { componentsRoutes as routes };
